import { CategoriaTO } from "./CategoriaTO";

export class Tag {
    constructor(categoriaTO: CategoriaTO) {
        this.id = categoriaTO.id;
        this.nome = categoriaTO.nome;
        this.subCategorias = new Array<Tag>();
        this.subscriptionId = categoriaTO.subscriptionId;
        this.selected = false;

        categoriaTO.subCategorias.forEach((child) => {
            let newChild: Tag = {
                id: child,
                nome: child,
                subCategorias: null,
                subscriptionId: this.subscriptionId,
                selected: false
            };
            this.subCategorias.push(newChild);
        });
    }
    id: string;
    nome: string;
    subCategorias: Tag[];
    subscriptionId: string;
    selected: boolean;
}
